import { params } from "../../params";
import { useAuthorizedQuery } from "..";
import { TicketEventResponse } from "./ticket-event.model";
import { useAuthorizedMutation } from "..";

export function useGenerateShadowModeTickets() {
  return useAuthorizedMutation<TicketEventResponse>({
    url: `${params.API_URL}/platform/ticket-event/shadow-mode`,
    method: "POST",
  });
}
